import {Radio as PeacockRadio} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IRadioProps} RadioButtonProps
 * @property {string[]} items Items available to select.
 * @property {string} reference Reference name used to group radio buttons.
 * @property {boolean} [selected] When true, renders the radio button as selected.
 * @property {boolean} [disabled] When true, renders in disabled mode.
 * @property {import('@pepsico-ds/ui').ILabelProps | string} [label] Label configuration for the radio group.
 * @property {boolean} [optional] When true, marks the radio group as optional.
 * @property {string} [altText] Alternative text for the required/optional indicator.
 * @property {(newSelectedIndex: number, value: string) => void} [onUpdate] Callback triggered when selection changes.
 * @property {number} [selectedItemIndex] Index of the currently selected item.
 * @property {'small' | 'large'} [size] Render size. Defaults to small.
 * @property {string | import('react').ReactNode} [helperText] Helper text shown below the group.
 * @property {'vertical' | 'horizontal'} [orientation] Layout orientation.
 * @property {boolean} [showText] When false, hides radio labels. Defaults to true.
 * @property {boolean} [skeleton] Renders skeleton state.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Radio.
 * Supports all Peacock DS radio props.
 * @param {RadioButtonProps} props
 */
export const RadioButton = props => {
  return <PeacockRadio {...props} />
}
